import React from 'react';

const Series = () => <div>Dummy Series Page</div>;

export default Series;
